// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/MagicDrawer/styles.css
// module id = 487
// module chunks = 0